import React from 'react';
import DataTable from 'react-data-table-component';

import Pagination from '../Pagination';

import down from '../../assets/images/down-arrow.svg'
import top from '../../assets/images/down-arrow.svg'

export const DataTableList = (props) => {
    const CustomPagination = () => {
        return (
            <Pagination 
                totalPage={props?.paginationTotalRows} 
                currentPage={props?.currentPage} 
                setCurrentPage={props?.onChangePage} 
            />
        );
    }
    return (
        <DataTable
            columns={props?.columns}
            data={props?.data}
            selectableRows={props?.selectableRows}
            selectableRowDisabled={props?.selectableRowDisabled}
            onSelectedRowsChange={props?.onSelectedRowsChange}
            onSort={props?.onSort} 
            progressPending={props?.progressPending}
            progressComponent={props?.progressComponent}
            pagination={props?.paginationTotalRows > 1 ? true : false}
            paginationComponent={CustomPagination}
            paginationServer
            onChangePage={props?.onChangePage}
            paginationTotalRows={props?.paginationTotalRows}
            customStyles={props?.customStyles}
            selectableRowsComponent={props?.selectableRowsComponent}
            selectAllRows={props?.selectAllRows}
            onSelectAllChange={props?.onSelectAllChange}
            clearSelectedRows={props?.clearSelectedRows}
            sortIcon={(sortDirection) => {
                if (sortDirection === 'asc') {
                  return <img src={top} alt="Ascending Sort" style={{ width: '16px', height: '16px' }} />;
                } else {
                  return <img src={down} alt="Descending Sort" style={{ width: '16px', height: '16px' }} />;
                }
            }}
            noDataComponent={props?.noDataComponent}
        />
    );
}